// extracted by mini-css-extract-plugin
export default {"app":"app_app__MT1Vw","header":"app_header__VxavQ","logo":"app_logo__IIn1j","sparkles":"app_sparkles__cnA7p"};